import {
  QueryUserTypeAndInfoResult,
  ResourceCodeEnums,
  UserTypeEnum,
} from "@/api/dmp_common/interface";
import React from "react";

export interface GlobalContextType extends QueryUserTypeAndInfoResult {
  initEnd?: boolean;
  resourceCodeList?: ResourceCodeEnums[];
  /** 是否是品牌账号. 用来判断例如 是否能选择店铺 等 */
  isBrand?: boolean;
}

const GlobalContext = React.createContext<GlobalContextType>({
  name: "",
  userPicUrl: "",
  mallId: 0,
  userType: UserTypeEnum.NORMAL,
  brandInfoList: [],
  resourceCodeList: [],
  showResourceCodeList: [],
  initEnd: false,
  reachNormalCondition: false,
  isBrand: false,
});

export default GlobalContext;
